import React, { lazy, useEffect } from "react";
import "../Styles/style.css";
import { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import SeoMeta from "../meta";
import { AuthContext } from "../../context/AuthContext";
import axios from "axios";
import { baseUrl } from "../../api/ipconfig";
import NumberLogin from "../loginModal/number";
import { Grid, Modal } from "@mui/material";
import Lottie from "lottie-react";

//Images
import LiveAnimation from "../../images/json/live.json";
import Jazzcash from "../../images/jazzcash.png";
import Payfast from "../../images/PayFastLogo.png";
import BAFL from "../../images/bafl-logo-home.png";
import BALH from "../../images/al-habib.png";
import NBP from "../../images/nbp.png";
import CarsBidding from "../../images/cars-live-bidding.webp";
import NewCarInspectionIcon from "../../images/inspection-new-vector.png";
import OurLiveBiddings from "../../images/our-live-bidding.png";
import FwBecomeMember from "../../images/famewheels-become-a-member.png";

import SellFamewheels from "../../images/services-icon/sell-famewheels.png";
import BuyBidding from "../../images/services-icon/buy-bidding.png";
import FwInspection from "../../images/services-icon/famewheels-inspection.png";
import InsuranceIcon from "../../images/services-icon/car-insurance-icon.png";
import FinanceIcon from "../../images/services-icon/car-finance-icon.png";
import CarSuggestionIcon from "../../images/car-suggestion-icon-1.png";
import useFetchMake from "../../customHooks/useFetchMake";
import useFetchCities from "../../customHooks/useFetchCity";
import TPLBannerImg from "../../images/tpl-banner-btm.jpg";
import Manufactures from "../manufecturers";
import CarSuggestBanner from "./CarSuggestBanner";
import UserAds from "./UserAds";

const TopSlider = lazy(() => import("./topSlider"));
const OurServices = lazy(() => import("./OurServices"));
const CategorySlider = lazy(() => import("./categorySlider"));
const FeaturedUsedCars = lazy(() => import("./featuredCars"));
const BrowseCars = lazy(() => import("./BrowseCars"));
const InspectionBanner = lazy(() => import("./InspectionBanner"));
const PaymentPartners = lazy(() => import("./PaymentPartners"));
const OurVideos = lazy(() => import("./OurVideos"));
const AboutUs = lazy(() => import("./AboutUs"));
const GetAppBanner = lazy(() => import("./GetAppBanner"));
const BrowseCarCategory = lazy(() => import("./BrowseCarCategory"));
const ManagedByFWCars = lazy(() => import("./managedbyFWCars"));
const HomeUsedCars = lazy(() => import("./usedCars"));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function Home() {
  const { user } = React.useContext(AuthContext);

  const [isOpen, setIsOpen] = useState(false);

  const { make, error } = useFetchMake(baseUrl);

  const { cities } = useFetchCities(baseUrl);
  const LoginOpen = () => {
    setIsOpen(true);
  };

  const LoginClose = () => {
    setIsOpen(false);
  };

  const [bidAmount, setBidAmount] = useState("");

  React.useEffect(() => {
    const fetchBidAmount = async () => {
      try {
        const response = await axios.get(`${baseUrl}/getBidAmount`);

        setBidAmount(response?.data);
      } catch (error) {
        console.error("Error fetching bid amount:", error);
      }
    };

    fetchBidAmount();
  }, []);

  const [scrollY, setScrollY] = useState(0);

  React.useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (!window.googletag) {
      console.error("Google Publisher Tag (GPT) is not loaded.");
      return;
    }

    window.googletag = window.googletag || { cmd: [] };

    window.googletag.cmd.push(() => {
      // Top Ad
      window.googletag
        .defineSlot(
          "/23203048013/HomeBetween728x90",
          [728, 90],
          "div-gpt-ad-1743153058700-0"
        )
        .addService(window.googletag.pubads());

      // Enable ads
      window.googletag.pubads().enableSingleRequest();
      window.googletag.enableServices();

      // Display ads
      window.googletag.display("div-gpt-ad-1743153058700-0"); // Between Ad
    });
  }, []);

  return (
    <>
      <div>
        <SeoMeta
          title="FameWheels - Car Live Bidding and Cars for sale in Pakistan"
          desc="Pakistan’s No 1 automobile website Buy and Sale Cars, Provides car bidding, car inspection and Post a free Ad and reach thousands of sellers and buyers. Connect with Fame Wheels for latest updates on Toyota, Suzuki and Honda used Cars, new cars and everything related to the automobiles."
          url="bidding"
        />

        <TopSlider make={make} cities={cities} />
        <OurServices />
        <Manufactures makes={make} />
        <div className="container">
          <div className="my-5">
            <ManagedByFWCars />
          </div>
        </div>
        {/* <SearchBar /> */}


        <UserAds />
       
        <CategorySlider cities={cities} />

        <div className="row align-items-center text-center my-2 w-100">
          <div
          className="d-none d-md-inline"
            id="div-gpt-ad-1743153058700-0"
            style={{ minWidth: "728px", minHeight: "90px" }}
          ></div>
        </div>
        <FeaturedUsedCars />

        <BrowseCarCategory />
        <InspectionBanner />

        <CarSuggestBanner />


        <BrowseCars />

        {/* <div className="container">
          <Link to="/tpl-insurance">
            <img
              src={TPLBannerImg}
              className="img-fluid rounded-3 boxShadow"
              alt=""
              srcSet={TPLBannerImg}
            />
          </Link>
        </div> */}

        <GetAppBanner />
        <OurVideos />
        {/* <AboutUs /> */}
        <PaymentPartners />
      </div>

      <Modal
        open={isOpen}
        onClose={LoginClose}
        disableAutoFocus={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="Fw-popups"
      >
        <Box className="sm-modal p-3 p-md-4">
          <div className="modalBody_area  px-2 ">
            <NumberLogin />
          </div>
        </Box>
      </Modal>
    </>
  );
}
